import { httpRequest } from '@/services/http'

const _postPlan = async ({ payload }) => {
  const response = await httpRequest({
    url: '/plan-selection',
    options: { method: 'PUT', body: JSON.stringify(payload) }
  })

  if (response.error) return response

  return response
}

export default {
  post: _postPlan
}
